export enum Pages {
    Login = 'Login',
    UpdatePassword = 'UpdatePassword',
    CreatePassword = 'CreatePassword',
    ResetPassword = 'ResetPassword',
    Balances = 'Balances',
    PaymentInvoices = 'PaymentInvoices',
    PayoutInvoices = 'PayoutInvoices',
}
